/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import withPieEncryption from '@vz-soe-utils/pieencryption';
import ContactInfo from '../../../components/Web/ContactInfo/redesign/FuncComp/index';
import * as contactInfoActions from '../actions';
import injectReducer from '../../../utils/injectReducer';
import injectSaga from '../../../utils/injectSaga';
import taggingSaga from '../../Common/Tagging.js/sagas';
import saga from '../sagas';
import contactInfo from '../reducer';
import * as cartActions from '../../../services/Cart/actions';
import cartSaga from '../../../services/Cart/sagas';
import * as taggingActions from '../../Common/Tagging.js/actions';

import { checkPlanReferenceData } from '../../../utils/plansReference';
import { getAPPID } from '../../../components/common/Helpers/index';
import * as paymentActions from '../../PaymentInfo/actions';
import paymentInfo from '../../PaymentInfo/sagas';
import checkOutSaga from '../../FuncComp/sagas';
import getCheckOutDetails from '../../FuncComp/reducer';
import * as checkOutActions from '../../FuncComp/actions';

const mapStateToProps = (state, ownProps) => {
  const contactBillingInfo = state.contactInfo ? state.contactInfo.contactBillingInfo : {};
  const editcontactInfo = state.contactInfo ? state.contactInfo.editContactInfo : {};
  const isCartVisible = state.cartDetails.isCartVisible || {};
  const cartDetails = state.checkout?.cart;
  const ShippingInfoDetails = state.checkout?.shipment;
  const setupType = state?.checkout?.depletionType
    ? state.checkout?.depletionType?.indexOf('F') > -1
      ? 'Self'
      : 'Prof'
    : cartDetails?.cartDetailsJson?.orderDetailsView?.installType?.indexOf('Prof') > -1
      ? 'Prof'
      : 'Self';

  const isEmailSuccess = state.contactInfo ? state.contactInfo.emailAPiResponse : {};
  const validateOrder = state.checkout?.orderDetails || {}; // getValidateOrder(state.cartDetails);
  const creditStatus = validateOrder?.orderList?.[0] || {};
  const isCreditHold = creditStatus?.creditApplication?.creditApprovalStatus && creditStatus?.creditApplication?.creditApprovalStatus !== 'AP'; // getCreditHoldStatus(state.cartDetails);
  const isCreditStatusAvailable = isCreditHold || state.checkout?.validateOrderDetails?.downpaymentRequired;
  const plansReferenceData = checkPlanReferenceData(state.plansReferenceData);
  const billingFormValues = state.contactInfo && state.contactInfo.billingFormInfo ? state.contactInfo.billingFormInfo : {};
  //  hold the contact info values in reducer [form values, buttonenablestatus]
  const contactFormValues = state.contactInfo && state.contactInfo.contactFormInfo ? state.contactInfo.contactFormInfo : {};

  const isInvalidZipcodeError = state.contactInfo && state.contactInfo.isInvalidZipcodeError;
  //  used for nse flow

  const billingInfoEdited = state.contactInfo && state.contactInfo.billingInfoEdited ? state.contactInfo.billingInfoEdited : false;

  const apiResponse =
    state.contactInfo && state.contactInfo.response && state.contactInfo.response && state.contactInfo.response.serviceHeader
      ? state.contactInfo.response.serviceHeader
      : null;
  const currentView = state.currentView || {};
  const isUpdateInfoSuccess = state.contactInfo?.isUpdateInfoSuccess;
  const billingAddressError = state.contactInfo?.billingAddressError;
  const isUpdateIspuInfoFlag = state.contactInfo?.isUpdateIspuInfoFlag;
  const isLoggedIn = getAPPID() === 'AAL';
  const contactInfoEditError = state.contactInfo ? state.contactInfo.contactInfoEditError : {};
  const contactFormInfoEnableBtn = !!contactInfoEditError; // used for nse flow
  const paymentInfoState = state && state.paymentInfo; // payment state used
  const paymentOptions = state.checkout?.payment?.paymentOptions;
  const payments = [];
  if (paymentOptions) {
    Object.keys(paymentOptions).forEach((data) => {
      const payment = paymentOptions[data];
      payments.push(payment);
    });
  }
  //  need to check in the object instead of array
  const isBTAAvailable = payments && payments.filter((item) => item.paymentType === 'AC');
  let otherPaymentOptions = [];
  let savedcardOption = payments && payments.filter((item) => item.paymentType === 'CR' && item.savedCCList && item.savedCCList.length !== 0);
  savedcardOption = savedcardOption && savedcardOption.map((obj) => ({ ...obj, paymentType: 'SC' }));
  otherPaymentOptions = payments && payments.concat(savedcardOption);
  const isBTAEligible = state && state.shippingInfo && state.shippingInfo.isBTAEligible;
  const shippingInfoState = state.shippingInfo; // paymentskip
  const updatePersonalError = state.contactInfo?.showContactPageError;
  const serviceinfo = state?.contactInfo?.serviceinfo;
  const creditStatusLanded = state.creditStatus?.creditStatusLanded;

  const billingContactInfo = state.contactInfo?.billingFormInfo || {};

  const contactInvalidCaseError = state.contactInfo?.contactInvalidCaseError;
  const contactInfoError = state.contactInfo?.contactInfoError || false;
  const contactInfoNtfyMsg = state.contactInfo?.contactInfoNtfyMsg || null;
  const eidQuestionsFromCreditStatus = state.creditCheckDetails?.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.eidQuestionnaire;
  const isEmailExists =
    state.contactInfo?.emailAPiResponse?.amValidationResponse?.emailAddressAsUserId === 'true' ||
    ((state.contactInfo?.emailAPiResponse?.valid === 'Valid' || state.contactInfo?.emailAPiResponse?.valid === 'White_listed') &&
      !state.contactInfo?.emailAPiResponse?.amValidationResponse);
  const { universalProfileCreationBannerMessages } = ownProps;
  const passwordValidationFailed = state.contactInfo?.passwordValidationFailed;
  const apiLoaded = state.SessionValues?.apiLoaded;
  const {
    emailMaxAttempts,
    password,
    isPasswordRulesCheckboxChecked,
    previousEmail,
    isUniversalProfileCreated,
    universalProfileCreationStatus,
    isCradleSuccess,
  } = state.contactInfo;
  const cartState = state.cartDetails;
  const getCheckOutInfo = state.checkout?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.primaryUserInfo || null;
  const getCheckOutState = state.checkout?.getCheckoutResponse || {};
  const contactInfoEditResponse = state.contactInfo ? state?.contactInfo?.contactInfoEditResponse : {};
  const paymentDoneList = state.checkout?.lineDetails?.payments;

  return {
    cartState,
    contactInfoEditResponse,
    isCartVisible,
    getCheckOutState,
    contactBillingInfo,
    editcontactInfo,
    cartDetails,
    setupType,
    currentView,
    plansReferenceData,
    isCreditStatusAvailable,
    billingFormValues,
    contactFormValues,
    isInvalidZipcodeError,
    billingInfoEdited,
    apiResponse,
    isUpdateInfoSuccess,
    billingAddressError,
    isLoggedIn,
    contactInfoEditError,
    isEmailSuccess,
    contactFormInfoEnableBtn,
    paymentInfoState,
    isBTAAvailable,
    isBTAEligible,
    otherPaymentOptions,
    shippingInfoState,
    updatePersonalError,
    serviceinfo,
    ShippingInfoDetails,
    creditStatusLanded,
    eidQuestionsFromCreditStatus,
    contactInvalidCaseError,
    emailMaxAttempts,
    billingContactInfo,
    isUpdateIspuInfoFlag,
    contactInfoError,
    contactInfoNtfyMsg,
    isUniversalProfileCreated,
    password: password || '',
    passwordValidationFailed,
    isEmailExists,
    universalProfileCreationStatus,
    universalProfileCreationBannerMessages,
    isPasswordRulesCheckboxChecked,
    previousEmail,
    isCradleSuccess,
    apiLoaded,
    getCheckOutInfo,
    paymentDoneList,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...contactInfoActions,
      ...cartActions,
      ...taggingActions,
      ...paymentActions,
      ...checkOutActions,
    },
    dispatch,
  );
}

const withReducer = compose(
  injectReducer({ key: 'contactInfo', reducer: contactInfo }),
  injectSaga({ key: 'paymentInfo', saga: paymentInfo }),
  injectReducer({ key: 'checkout', reducer: getCheckOutDetails }),
);

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withSaga = compose(
  injectSaga({ key: 'contactInfo', saga }),
  injectSaga({ key: 'cartDetails', saga: cartSaga }),
  injectSaga({ key: 'taggingDetails', saga: taggingSaga }),
  injectSaga({ key: 'checkoutDetails', saga: checkOutSaga }),
);

export default withRouter(
  compose(withSaga, withReducer, withConnect)(withPieEncryption(ContactInfo, window.vzFlags && window.vzFlags.isProd ? 'PRODUCTION' : 'UAT')),
);
